// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__G+oNh","status":"style_status__CoZLi","report":"style_report__H-4mv"};